export const related_spend_display = {
  heading: "Related spend",
  empty: "No repair spend allocations linked yet",
  col_amount: "Amount",
  col_note: "Note",
  col_transaction: "Transaction",
  view_transaction: "View transaction",
  empty_cell: "—",
};
